import { createHomeUrl } from 'features/domains/utils'
import { StyledLicenseLink } from '../styles'

interface LicensesHomeLinkCellProps {
  homeId: string
  homeName: string | null
  homeRootDomainId: string
}

function LicensesHomeLinkCell(
  props: LicensesHomeLinkCellProps
): React.ReactElement {
  const { homeId, homeName, homeRootDomainId } = props

  if (!homeRootDomainId) {
    return <div>{homeName ?? '-'}</div>
  }
  const homeUrl = createHomeUrl(homeRootDomainId, homeId)

  return homeName ? (
    <StyledLicenseLink to={homeUrl}>{homeName}</StyledLicenseLink>
  ) : (
    <div>-</div>
  )
}

export default LicensesHomeLinkCell
